import React from "react";

interface Props {
  items: Spec[];
}

interface Spec {
  label: string;
  value: string;
}

export const Specs = ({ items }: Props) => {
  return (
    <div className="grid grid-cols-2 gap-x-8 gap-y-6 md:grid-cols-3 xl:gap-x-12">
      {items.map(({ label, value }, index) => (
        <div
          className="flex flex-col items-center text-black xl:items-start"
          key={index}
        >
          <div className="font-content text-xl">{label}</div>
          <div className="font-title text-3xl">{value}</div>
        </div>
      ))}
    </div>
  );
};
